<template>
  <tr>
    <td>
      {{item.descricao}}
    </td>

    <td class="edit">
        <!--
      <i class="mdi mdi-square-edit-outline pointer"
         v-tooltip="'Editar'"
         @click="edit"></i>-->

        <v-icon size="20"
                slot="activator"
                v-tooltip="$t('message.generics.message.remove')"
                @click="remove">mdi-delete</v-icon>

    </td>
    <app-confirmation-modal :value="!!pendingRemove"
                            :confirm-label="$t('message.generics.message.confirm')"
                            @confirm="confirmRemove"
                            @cancel="cancelRemove">
      <span slot="heading">
        {{$t('message.generics.message.excludeTag')}}
      </span>
      <span>
        {{$t('message.generics.message.confirmExclusion')}}
      </span>
    </app-confirmation-modal>
  </tr>
</template>

<script>
    // import AppToggle from '@components/Toggle'
    import AppConfirmationModal from '@components/ConfirmationModal'
    import EventBus from '@packages/event-bus/index'
    export default {
        components: {
            // AppToggle,
            AppConfirmationModal
        },

        props: {
            dataItem: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                entity: 'tag',
                pendingRemove: null
            }
        },

        computed: {
            item() {
                return this.dataItem
            },

        },

        methods:{
            remove() {
                this.pendingRemove = this.item.id;
            },
            async confirmRemove() {
                await this.$api.tag.remove(this.item.id)
                this.pendingRemove = null
                EventBus.$emit('LOAD_TAGS')
            },

            cancelRemove(){
                this.pendingRemove = null
            },

            edit() {
                EventBus.$emit('EDIT_TAG', this.item)
            },

        }
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.edit {
  .mdi {
    font-size: 18px;

    &:not(:last-child) {
      margin-right: 6px;
    }
  }
}
.imgEstablishment {
  max-height: 42px;
  border-radius: 10px;
  margin-top: 5px;
}

.icon-green {
  color: $primary;
}
</style>
